












import {Component, Vue, Inject, Prop, Watch} from 'vue-property-decorator';
import Util from '@/lib/util'
import AbpBase from '@/lib/abpbase'
import _ from "lodash"
import $ from "jquery"
import ajax from '@/lib/ajax';
import {EMPTY_ARRAY, EMPTY_OBJECT} from "../lib/appconst";
import breadcrumbRoutes from "../store/modules/breadcrumbRoutes";


//自定义面包屑组件

@Component({
  components: {},
})
export default class cBreadcrumb extends AbpBase {
  //传入数据
  @Prop({type: Array, default: EMPTY_ARRAY})
  routes;
  //待替换的token,传入的格式必须为{0:'',1:''}的字典
  @Prop({type: Object, default: EMPTY_OBJECT})
  tokens;

  basePath = '';

  /**
   * 替换title里面的待替换token
   */
  replaceTitle(title: string) {
    // debugger
    let self = this;
    if (!this.tokens || this.tokens.length == 0) {
      return;
    }
    let rep = /({{\S+?}})/g;
    let matchedList = title.match(rep);
    _.each(matchedList, (val, ind) => {
      let key = val.replace("{{", "").replace("}}", "");
      if (!self.tokens[key]) {
        title = '';
      } else {
        title = title.replace(val, self.tokens[key]);
      }
    })
    return title;
  }


  getRoutes() {
    let routerData = this.$store.state.breadcrumbRoutes.routers.map((p) => {
      let data = {};
      if (this.replaceTitle(p.meta.title)) {
        data = {
          'breadcrumbName': this.replaceTitle(p.meta.title),
          "path": p.path,
        }
      }
      return data
    })

    if (!_.find(routerData, {breadcrumbName: '首页'})) {
      routerData.unshift({
        path: '/globalList',
        breadcrumbName: '首页',
      })
    }
    return routerData;
  }

  @Watch("tokens")
  tokenChanged() {
    this.$forceUpdate();
  }
}
